import { Directive } from '@angular/core';

@Directive({
  selector: '[title]'
})
export class TitleDirective {

  constructor() { }

}
